import React from 'react';
import wix from '../services/wix';
import * as biLogger from '../services/biLogger';
import { expandCollapseManager } from '@wix/chat-web';
import { chatEventEmitter } from '@wix/chat-sdk';
import { loadingScheduler } from '../services/loading-scheduler';

export interface MobileProps {
  deviceType: string;
  host: string;
  primaryColor: string;
  chatOnPage: boolean;
}

export interface MobileState {
  isMobile: boolean;
  isResponsive: boolean;
}

const mobile = (
  WrappedComponent: React.ComponentType<any>,
): React.ComponentType<any> => {
  return class extends React.Component<MobileProps, MobileState> {
    private wrappedComponent;

    constructor(props) {
      super(props);
      this.state = {
        isMobile: this.props.deviceType === 'mobile',
        isResponsive: false,
      };
    }

    onNewMessage = () => {
      wix.updateQab({
        notifications: true,
        color: this.props.primaryColor,
      });
    };

    async componentDidMount() {
      const { host } = this.props;

      const { booleans } = await wix.getStyleParams();
      const isResponsive = !!booleans?.responsive;
      this.setState({ isResponsive });

      if (this.state.isMobile && !isResponsive) {
        expandCollapseManager.registerOnCollapse(this.handleCollapse);
        wix.registerQab(async () => {
          await loadingScheduler.onInteractive();
          wix.showMobileComponent();
          this.wrappedComponent.onPostExpand &&
            this.wrappedComponent.onPostExpand();
          biLogger.expandChatEvent({
            direction: 'uou',
            referrer: 'widget',
            host,
          });
        });

        chatEventEmitter.addListener(
          chatEventEmitter.CHAT_EVENTS.NEW_REALTIME_MESSAGE,
          this.onNewMessage,
        );
      }
    }

    componentWillUnmount() {
      chatEventEmitter.removeListener(
        chatEventEmitter.CHAT_EVENTS.NEW_REALTIME_MESSAGE,
        this.onNewMessage,
      );
    }

    handleMessageReceived = () => {
      const { isMobile, isResponsive } = this.state;

      if (isMobile && !isResponsive) {
        wix.updateQab({
          visible: true,
          notifications: true,
          color: this.props.primaryColor,
        });
      }
    };

    handleCollapse = () => {
      const { isMobile, isResponsive } = this.state;

      if (isMobile && !isResponsive) {
        wix.hideMobileComponent();
        wix.updateQab({
          visible: this.props.chatOnPage,
          notifications: false,
          color: this.props.primaryColor,
        });
      }
    };

    render() {
      return (
        <WrappedComponent
          ref={(component) => (this.wrappedComponent = component)}
          onMessageReceived={this.handleMessageReceived}
          isResponsive={this.state.isResponsive}
          {...this.props}
        />
      );
    }
  };
};

export default mobile;
